export default "/assets/images/basic-breather1.d1ff895a99dd79f8.png";